const validateOrShowError = (value, validateFunction, errorMessage) =>
  !validateFunction(value) ? errorMessage : true;

const validatePassword = (value) => {
  let count = 0;
  if (validateHasAtLeastOneNumber(value)) count++;
  if (validateHasAtLeastOneLowercase(value)) count++;
  if (validateHasAtLeastOneUppercase(value)) count++;
  if (validateHasAtLeastOneSymbol(value)) count++;
  return count >= 3;
};

const validateHasAtLeastOneNumber = (value) => value && /.*\d.*/.test(value);

const validateHasAtLeastOneLowercase = (value) =>
  value && /.*[a-z].*/.test(value);

const validateHasAtLeastOneUppercase = (value) =>
  value && /.*[A-Z].*/.test(value);

const validateHasAtLeastOneSymbol = (value) =>
  value && /.*[$&+,:;=\\\\?@#|/'<>.^*()%!-].*/.test(value);

const validateIsEmail = (value) =>
  value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

const validateTaxId = (taxId) => {
  if (!taxId || !taxId.match(/^\d{9}$/) || taxId === '000000000') {
    return false;
  }

  let m = 1;
  let sum = 0;
  for (let i = 7; i >= 0; i--) {
    m *= 2;
    sum += taxId.charAt(i) * m;
  }

  return (sum % 11) % 10 === parseInt(taxId.charAt(8), 10);
};

const validateGreekMobilePhone = (value) =>
  value && /^(\+30|0030)?69\d{8}$/.test(value.replace(/[\s\-().]/g, ''));

const validateGreekLandlinePhone = (value) =>
  value && /^(\+30|0030)?(2)\d{9}$/.test(value.replace(/[\s\-().]/g, ''));

const validateGreekPhone = (value) =>
  validateGreekMobilePhone(value) || validateGreekLandlinePhone(value);

const validateGreekMobilePhoneNoPrefix = (value) =>
  value && /^69\d{8}$/.test(value.replace(/[^0-9]/g, ''));

const validateGreekLandlinePhoneNoPrefix = (value) =>
  value && /^2\d{9}$/.test(value.replace(/[^0-9]/g, ''));

const validateGreekPhoneNoPrefix = (value) =>
  validateGreekMobilePhoneNoPrefix(value) ||
  validateGreekLandlinePhoneNoPrefix(value);

const validateAmountTwoDecimalsFormat = (value) =>
  value && /^\d*((\.{1}|,{1})\d{1,2})?$/.test(value);

const validateAmountFormat = (value) =>
  value && /^\d*((\.{1}|,{1})\d*)?$/.test(value);

export {
  validateOrShowError,
  validateTaxId,
  validateGreekMobilePhone,
  validateGreekLandlinePhone,
  validateGreekPhone,
  validateGreekMobilePhoneNoPrefix,
  validateGreekLandlinePhoneNoPrefix,
  validateGreekPhoneNoPrefix,
  validatePassword,
  validateIsEmail,
  validateAmountFormat,
  validateAmountTwoDecimalsFormat,
};
